import { blackColors } from 'assets/jss/material-dashboard-pro-react';

const addNumbersDialogStyle = (theme) => ({
	dialogBodyWrapper: {
		padding: '0 48px',
		minHeight: '385px',
		[theme.breakpoints.down('xs')]: {
			padding: '0 12px',
		},
	},
	filters: {
		display: 'flex',
		alignItems: 'flex-end',
		justifyContent: 'flex-start',
		[theme.breakpoints.down('xs')]: {
			flexDirection: 'column',
			'& > div': {
				width: '100%',
			},
		},
		[theme.breakpoints.up('sm')]: {
			'& > div': {
				flexBasis: 0,
				flexGrow: 1,
				'&:first-of-type': {
					marginRight: '16px',
				},
				'&:last-of-type': {
					marginLeft: '16px',
				},
			},
		},
	},
	searchIcon: {
		height: '16px',
		width: 'auto',
		marginBottom: theme.direction === 'rtl' ? 8 : 0,
	},
	selectedItem: {},
	numberInfo: {
		display: 'flex',
		alignItems: 'center',
		marginBottom: '10px',
		'& > p': {
			position: 'relative',
			bottom: '-1px',
			marginRight: '4px',
		},
		'& svg': {
			width: '16px',
			height: '16px',
			color: blackColors[3],
			marginRight: '4px',
			'&:first-of-type': {
				color: blackColors[4],
				marginRight: '10px',
			},
		},
	},
	tag: {
		whiteSpace: 'nowrap',
	},
	numbersWrapper: {
		marginTop: '20px',
	},
});

export default addNumbersDialogStyle;
